import corporateClientAppModel from "./corporate_client_app.model";
import { CrudModel } from "./_crud";
import { crudGet, crudRead } from "./_request";

export class clientAppModel extends CrudModel {
	constructor() {
		super("app/client", [], [{ fieldKey: "solutionCategory", model: corporateClientAppModel }]);
	}

	async getClientList(listDto: any) {
		return this.get("", listDto);
	}

	async read(id: string, queryParameters: any = {}) {
		return crudRead(this.endpoint, id, queryParameters);
	}

	async getClientSummary(clientId: string) {
		return crudGet(`${this.endpoint}/summary`, clientId);
	}

	async getNewAccessCode(clientId: string) {
		return crudGet(`${this.endpoint}/accessCode`, clientId);
	}
}

export default new clientAppModel();
